module.exports = __webpack_public_path__ + "img/upgraded-member-count.dd6b5c90.svg";